import React, { Component, createRef } from 'react';
import ValidationText from "../../utils/validation/ValidationText.js";
import { CommonValidationMessages } from '../../utils/Messages.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';
import { printFunction } from '../../components/print/printTemplate.js';

class ItemWiseDespatch extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            companyName: '',
            gstInvoiceFinishGoodsItemList: [],
            itemListing: [],
            filterDetails: {
                startDate: "",
                endDate: "",
                totalSales: "",
                itemName: "",
            },
            totalCount: 0,
            noItemFound: '',
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllItemWiseDesptach(false);
        const company = getAuthProps()
        this.setState({ companyName: company?.companyName })
    }

    getAllItemWiseDesptach = (isItemListingRequire) => {
        let request = this.state.filterDetails
        this.despatchServices.getAllItemWiseDesptach(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {

                let res = response.responseData
                if (res.gstInvoiceFinishGoodsItemListing.length === 0) {
                    this.setState({ noItemFound: "No item found" });
                }
                const uniqueGstIds = new Set();
                const totalSum = res.itemListing.reduce((sum, item) => {
                    const gstId = item.gstInvoiceFinishGoodsId._id;
                    if (!uniqueGstIds.has(gstId)) {
                        uniqueGstIds.add(gstId);
                        sum += item.gstInvoiceFinishGoodsId.grandTotal;
                    }
                    return sum;
                }, 0);
                let details = this.state.filterDetails
                details.totalSales = totalSum

                let totalCount = res.itemListing.length

                this.setState({
                    gstInvoiceFinishGoodsItemList: res.gstInvoiceFinishGoodsItemListing,
                    filterDetails: details,
                    itemListing: isItemListingRequire === false ? [] : res.itemListing,
                    totalCount: totalCount
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };


    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.startDate = ""
        Fdetails.endDate = ""
        Fdetails.itemName = ""
        Fdetails.totalSales = ""
        this.setState({
            filterDetails: Fdetails, totalCount: 0, noItemFound: '', partyWiseDespatchList: [], itemListing: []

        }, () => {
            this.getAllItemWiseDesptach(false)
        });
    }
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details },
            () => {
                if (name !== 'startDate' && name !== 'endDate') {
                    this.getAllItemWiseDesptach()
                }
            }
        );

    };

    getAllItemWiseDespatchById = (itemName) => {
        let details = this.state.filterDetails
        details.itemName = itemName
        this.setState({ filterDetails: details }, () => {
            this.getAllItemWiseDesptach()
        })
    }

    render() {
        return (
            <div className='paryWiseDespatchReport-page'>
                <div className="item-search flex gap-2.5 !mb-1.5">
                    <div className="input-grp w-[29.6%]" >
                        <label>Start Date</label>
                        <input
                            className="inputFocus"
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.startDate}
                        /> */}
                    </div>
                    <div className="input-grp w-[29.6%]">
                        <label>End Date</label>
                        <input
                            className="inputFocus"
                            type="date"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            value={this.state.filterDetails.endDate}
                            onChange={(event) =>
                                this.handleChange(event, "endDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.endDate}
                        /> */}
                    </div>

                    <div className="btn-grp mt-auto">
                        <button className={`add-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`} onClick={() => this.getAllItemWiseDesptach()}>Search</button>

                        <button className={`cancel-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`} onClick={() => this.resetForm()}>Cancel</button>

                    </div>

                </div>
                <div className="item-search flex gap-2.5 !mb-2.5">
                    <div className="input-grp w-[40%]">
                        <label>Item Name</label>
                        <input
                            className="inputFocus"
                            type="text"
                            id="itemName"
                            name="itemName"
                            autoComplete="off"
                            value={this.state.filterDetails.itemName}
                            onChange={(event) =>
                                this.handleChange(event, "itemName")
                            }
                        />
                    </div>
                    <div className="input-grp w-[19.3%]">
                        <label>Total Sales</label>
                        <input
                            type="text"
                            id="totalSales"
                            name="totalSales"
                            disabled
                            autoComplete="off"
                            value={this.state.filterDetails.totalSales}
                            onChange={(event) =>
                                this.handleChange(event, "totalSales")
                            }
                        />
                    </div>
                    {this.state.itemListing && this.state.itemListing.length > 0 ?
                        <button className="print-btn mt-auto" onClick={() => printFunction()}>Print</button>
                        : null}
                </div>

                <div class="item-listing w-[60%]">
                    <div class="itemList-table">
                        <div class="table-container h-[23.5vh]" >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td style={{ width: "50%" }}>Item Name</td>
                                        <td style={{ width: "15%" }}>Sales</td>
                                        <td style={{ width: "15%" }}>Free</td>
                                        <td style={{ width: "20%" }}>Amount</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.gstInvoiceFinishGoodsItemList && this.state.gstInvoiceFinishGoodsItemList.length > 0 ? (
                                        this.state.gstInvoiceFinishGoodsItemList.map((details, key) => (
                                            <tr
                                                key={key}
                                                tabIndex="0"
                                                className="hover:bg-gray-200 cursor-pointer focus:bg-gray-200"
                                                onClick={() => this.getAllItemWiseDespatchById(details.itemName)}
                                            >
                                                <td>{details.itemName}</td>
                                                <td>{details.totalQty}</td>
                                                <td>{details.totalFree}</td>
                                                <td>{details.grandTotal}</td>
                                            </tr>
                                        ))
                                    ) : this.state.gstInvoiceFinishGoodsItemList
                                        && this.state.gstInvoiceFinishGoodsItemList.length === 0
                                        && this.state.noItemFound !== "" ? (
                                        <tr>
                                            <td colSpan={4} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {this.state.noItemFound}
                                            </td>
                                        </tr>
                                    ) : this.state.gstInvoiceFinishGoodsItemList
                                        && this.state.gstInvoiceFinishGoodsItemList.length === 0
                                        && this.state.noItemFound === "" ? null : ""}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="table-upper mt-2.5">
                    <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
                        Total Count :- {this.state.totalCount ? this.state.totalCount : 0}
                    </p>
                </div>
                <div class="item-listing">
                    <div className="hidden print-title">
                        <h4 className="text-black font-semibold text-[18px]">Itemwise Despatch</h4>
                        <p className="text-black">Item name:- {this.state.filterDetails.itemName}</p>
                    </div>
                    <div class="itemList-table">
                        <div class="table-container min-h-[45.5vh] max-h-[52vh]" >
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[8%]'>Inv. No.</td>
                                        <td className='w-[8%]'>Inv. Date</td>
                                        <td className='w-[15%]'>Party Name</td>
                                        <td className='w-[8%]'>Batch No</td>
                                        <td className='w-[8%]'>Qty.</td>
                                        <td className='w-[6%]'>Free</td>
                                        <td className='w-[5%]'>Rate</td>
                                        <td className='w-[9%]'>Amount</td>
                                        <td className='w-[9%]'>Total Amount</td>
                                        <td className='w-[8%]'>Transp. Name</td>
                                        <td className='w-[8%] no-print'>L.R. No</td>
                                        <td className='w-[8%] no-print'>L.R. Date</td>
                                    </tr>
                                </thead>

                                <tbody>
                                    {this.state.itemListing && this.state.itemListing.length > 0 ? (
                                        this.state.itemListing.map((details, key) => (
                                            <tr
                                                key={key}

                                            >
                                                <td>{details.gstInvoiceFinishGoodsId.invoiceNo}</td>
                                                <td>{moment(details.gstInvoiceFinishGoodsId.invoiceDate).format('DD MMM YYYY')}</td>
                                                <td>{details.gstInvoiceFinishGoodsId.partyId.partyName}</td>
                                                <td>{details.batchNo}</td>
                                                <td>{details.qty}</td>
                                                <td>{details.free}</td>
                                                <td>{details.rate}</td>
                                                <td>{details.amount}</td>
                                                <td>{details.gstInvoiceFinishGoodsId.grandTotal}</td>
                                                <td>{details.gstInvoiceFinishGoodsId.transportId.transportName}</td>
                                                <td className='no-print'>{details.gstInvoiceFinishGoodsId.lRNo ? details.gstInvoiceFinishGoodsId.lRNo : ''}</td>
                                                <td className='no-print'>{details.gstInvoiceFinishGoodsId.lRDate ? moment(details.gstInvoiceFinishGoodsId.lRDate).format('DD MMM YYYY') : ''}</td>
                                            </tr>
                                        ))
                                    ) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                {/*----- Print layout -----*/}
                <div className='table-print mt-5 hidden' id="printableArea">
                    {/* Header */}
                    <div className="print-header">
                        <table className="hdr-table">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="co-name">{this.state.companyName}</div>
                                        <div className="rpt-sub">Item Wise Despatch</div>
                                    </td>
                                    <td>
                                        <div className="hdr-meta">
                                            {this.state.filterDetails.startDate !== "" && (
                                                <>
                                                    Start Date: <strong>{this.state.filterDetails.startDate}</strong>
                                                    <br />
                                                </>
                                            )}
                                            {this.state.filterDetails.endDate !== "" && (
                                                <>
                                                    End Date: <strong>{this.state.filterDetails.endDate}</strong>
                                                </>
                                            )}
                                            Item name: <strong>{this.state.filterDetails.itemName}</strong>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="rule-thick" />
                        <div className="rule-thin" />
                    </div>


                    <div className="print-content">

                        {/* <div className="info-row">
                                                                      <div>
                                                                        <span className="info-label">Item Name:</span>
                                                                        <p className="info-value">Paracetamol</p>
                                                                      </div>
                                                                    </div> */}

                        {/* Table */}
                        <table className="data-tbl">
                            <colgroup>
                                <col style={{ width: "7%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "24%" }} />
                                <col style={{ width: "8%" }} />
                                <col style={{ width: "6%" }} />
                                <col style={{ width: "7%" }} />
                                <col style={{ width: "7%" }} />
                                <col style={{ width: "9%" }} />
                                <col style={{ width: "10%" }} />
                                <col style={{ width: "12%" }} />
                            </colgroup>

                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'left' }}>
                                        Inv No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Inv Date
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Party Name
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Batch No
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Qty
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Free
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Rate
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Amount
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Total Amt
                                    </th>
                                    <th style={{ textAlign: 'left' }}>
                                        Transp. Name
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.itemListing && this.state.itemListing.length > 0 ?
                                    this.state.itemListing.map((details, key) => (
                                        <tr key={key}>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.gstInvoiceFinishGoodsId.invoiceNo}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {moment(details.gstInvoiceFinishGoodsId.invoiceDate).format('DD MMM YYYY')}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.gstInvoiceFinishGoodsId.partyId.partyName}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.batchNo}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.qty}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.free}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.rate}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.amount}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.gstInvoiceFinishGoodsId.grandTotal}
                                            </td>
                                            <td style={{ textAlign: 'left' }}>
                                                {details.gstInvoiceFinishGoodsId.transportId.transportName}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan="10" style={{ textAlign: 'center' }}>
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                            </tbody>
                        </table>
                    </div>

                    {/* Footer */}
                    <div className="print-footer">
                        <div className="rule-foot">
                            <table className="foot-tbl">
                                <tbody>
                                    <tr>
                                        <td>* System generated report. No signature required.</td>
                                        <td style={{ textAlign: "right" }}>
                                            Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}

export default ItemWiseDespatch;